var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelatedPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1737 12.8881C17.355 12.8881 19.1233 11.1198 19.1233 8.93849C19.1233 6.7572 17.355 4.98891 15.1737 4.98891C12.9924 4.98891 11.2241 6.7572 11.2241 8.93849C11.2241 11.1198 12.9924 12.8881 15.1737 12.8881Z",
    fill: "#FEC212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0604 24.8853V20.3614C21.0604 17.1107 18.4244 14.4747 15.1737 14.4747C11.923 14.4747 9.28699 17.1107 9.28699 20.3614V24.8886L21.0604 24.8864V24.8853Z",
    fill: "#FEC212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33559 11.8245C4.6745 11.8245 2.51025 9.66025 2.51025 6.99917C2.51025 4.33808 4.6745 2.17384 7.33559 2.17384C9.99667 2.17384 12.1609 4.33808 12.1609 6.99917C12.1609 9.66025 9.99667 11.8245 7.33559 11.8245ZM7.33559 3.0474C5.15714 3.0474 3.38381 4.81963 3.38381 6.99917C3.38381 9.1787 5.15605 10.9509 7.33559 10.9509C9.51512 10.9509 11.2874 9.1787 11.2874 6.99917C11.2874 4.81963 9.51512 3.0474 7.33559 3.0474Z",
    fill: "#5A348C",
    stroke: "#5A348C",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7345 25C13.4931 25 13.2977 24.8045 13.2977 24.5632V20.2118C13.2977 16.9239 10.6235 14.2497 7.33562 14.2497C4.04775 14.2497 1.37356 16.9239 1.37356 20.2118V24.5632C1.37356 24.8045 1.1781 25 0.936781 25C0.695459 25 0.5 24.8045 0.5 24.5632V20.2118C0.5 16.4424 3.5662 13.3762 7.33562 13.3762C11.105 13.3762 14.1712 16.4424 14.1712 20.2118V24.5632C14.1712 24.8045 13.9758 25 13.7345 25Z",
    fill: "#5A348C",
    stroke: "#5A348C",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.505 11.2294C19.6844 11.2294 17.3903 8.93521 17.3903 6.1147C17.3903 3.29419 19.6844 1 22.505 1C25.3255 1 27.6197 3.29419 27.6197 6.1147C27.6197 8.93521 25.3255 11.2294 22.505 11.2294ZM22.505 1.87247C20.166 1.87247 18.2638 3.77465 18.2638 6.11361C18.2638 8.45257 20.1671 10.3547 22.505 10.3547C24.8428 10.3547 26.7461 8.45148 26.7461 6.11361C26.7461 3.77574 24.8428 1.87247 22.505 1.87247Z",
    fill: "#5A348C",
    stroke: "#5A348C",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3286 25C29.0873 25 28.8919 24.8045 28.8919 24.5632V19.7248C28.8919 16.2054 26.0266 13.3423 22.5039 13.3423C18.9813 13.3423 16.1215 16.2054 16.1215 19.7248V24.5632C16.1215 24.8045 15.926 25 15.6847 25C15.4434 25 15.2479 24.8045 15.2479 24.5632V19.7248C15.2479 15.7239 18.503 12.4688 22.5039 12.4688C26.5049 12.4688 29.7654 15.7239 29.7654 19.7248V24.5632C29.7654 24.8045 29.57 25 29.3286 25Z",
    fill: "#5A348C",
    stroke: "#5A348C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatedPersonIcon);
export default __webpack_public_path__ + "static/media/related-person-icon.1cdc36e3e4840c0b0be0303136e6bc85.svg";
export { ForwardRef as ReactComponent };